import { useState } from 'react';
import { useRouter } from 'next/router';

// Hooks
import { DuplicateDashboardProvider } from '@/utils/hooks/dashboard/useDuplicateDashboard';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Utils
import { post } from '@/utils/client';

// Lib
import { CREATE_DASHBOARD } from '@/lib/routes/apiEndpoints';
import { DASHBOARD_VIEW } from '@/lib/routes/privateRoutes';

// Components
import Button from '@/components/base/Button';
import Icon from '@/components/base/Icon';
import FeatureDescriptionDefault from '@/components/composite/FeatureDescription/FeatureDescriptionDefault';
// Hooks
import { EditNameModal } from '@/components/pages/custom-dashboards/modals/EditNameModal';

// Images
import illustrationEn from './../../../../../public/images/illustrations/dashboards/illustration-empty-dashboards-en.webp';

function DashboardEmpty() {
    const router = useRouter();
    const { t } = useTranslation('dashboard');
    const [dashboardEdit, setDashboardEdit] = useState({
        isEditing: false,
        isLoading: false
    });

    const handleChange = (e) => {
        e && e.preventDefault();
        setDashboardEdit({ ...dashboardEdit, isEditing: !dashboardEdit.isEditing });
    };

    const data = {
        title: t('dashboard:discover_feature.title'),
        description: t('dashboard:discover_feature.description'),
        sections: [
            {
                title: t('dashboard:discover_feature.section_1.title'),
                options: [
                    t('dashboard:discover_feature.section_1.option_1'),
                    t('dashboard:discover_feature.section_1.option_2'),
                    t('dashboard:discover_feature.section_1.option_3')
                ]
            },
            {
                title: t('dashboard:discover_feature.section_2.title'),
                options: [
                    t('dashboard:discover_feature.section_2.option_1'),
                    t('dashboard:discover_feature.section_2.option_2'),
                    t('dashboard:discover_feature.section_2.option_3')
                ]
            }
        ],
        illustration: {
            en: illustrationEn,
            fr: illustrationEn,
            es: illustrationEn
        },
        actionButton: (
            <Button onClick={handleChange} variant="secondary" className="create-new-add space-x-2">
                <span>{t('dashboard:discover_feature.button')}</span>
                <Icon icon="arrow-right" />
            </Button>
        )
    };
    return (
        <div className="flex flex-1 flex-col">
            <FeatureDescriptionDefault data={data} />
            <DuplicateDashboardProvider defaultValues={{ name: '', social_profiles: [] }}>
                <EditNameModal
                    isOpen={dashboardEdit.isEditing}
                    isLoading={dashboardEdit.isLoading}
                    toggle={handleChange}
                    onConfirm={async (name) => {
                        setDashboardEdit({ ...dashboardEdit, isLoading: true });
                        const { data } = await post(CREATE_DASHBOARD, { name });
                        router.push(DASHBOARD_VIEW.replace('[id]', data.id));
                    }}
                    onError={() => {
                        setDashboardEdit({ ...dashboardEdit, isLoading: false });
                    }}
                    title={undefined}
                    btnLabel={t('dashboard_confirm_btn_label')}
                />
            </DuplicateDashboardProvider>
        </div>
    );
}

export default DashboardEmpty;
